import { Icon, NumberInput, NumberInputField } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { BiX } from 'react-icons/bi';
import { useDebounce } from 'react-use';

export const DebouncedNumberInput = ({
    initialValue = '',
    debounceCallback,
    disabled,
}: {
    initialValue?: string;
    debounceCallback: (value: string) => void;
    disabled?: boolean;
}) => {
    const isMounted = useRef(false);
    const [displayValue, setDisplayValue] = useState(initialValue);

    useEffect(() => {
        setDisplayValue(initialValue);
    }, [initialValue]);

    useDebounce(
        () => {
            if (isMounted.current) {
                debounceCallback(displayValue);
            } else {
                isMounted.current = true;
            }
        },
        500,
        [displayValue],
    );

    return (
        <NumberInput
            size="xs"
            value={displayValue}
            onChange={(value) => setDisplayValue(value)}
            position="relative"
            isDisabled={disabled}
        >
            <NumberInputField />
            {displayValue.length > 0 && (
                <Icon
                    position="absolute"
                    right={1}
                    top="50%"
                    transform="translate(0, -50%)"
                    as={BiX}
                    color="teal.300"
                    cursor="pointer"
                    onClick={() => setDisplayValue('')}
                />
            )}
        </NumberInput>
    );
};
